module.exports = __webpack_public_path__ + "img/_m8_1cup.prt.0e1cb292.jpg";